'use client'

import Box from '@mui/material/Box'
import List from '@mui/material/List'
import { listItemClasses } from '@mui/material/ListItem'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'

import useCasesBackground from '../../../public/images/Use Cases Background.svg'

export const UseCasesBackground = styled(Box)(({ theme }) => ({
  background: `url("${useCasesBackground.src}") no-repeat 50%`,
  backgroundSize: 'cover',
  padding: theme.spacing(5.5, 0),
  color: theme.palette.common.white,
}))

export const UseCasesLayout = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2.5),

  [theme.breakpoints.down('md')]: {
    '> img': {
      maxWidth: '100%',
      height: 'auto',
    },
  },

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}))

export const UseCasesList = styled(List)(({ theme }) => ({
  ...theme.typography.body1,
  listStyleType: 'disc',
  padding: theme.spacing(0, 0, 0, 3),

  [`& .${listItemClasses.root}`]: {
    display: 'list-item',
  },
}))
